import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=a40186f8&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=a40186f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40186f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a40186f8')) {
      api.createRecord('a40186f8', component.options)
    } else {
      api.reload('a40186f8', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=a40186f8&scoped=true&", function () {
      api.rerender('a40186f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/setting/components/edit.vue"
export default component.exports